import { BodyText } from '@bamboohr/fabric';
import { deleteAllPasskeyCredentials, getPasskeyCredentials } from '@bamboohr/utils/lib/authentication';



export function openPasskeyResetModal({ firstName, userId, onSuccess = () => {} }) {

    const modalInitialState = {
        headline: $.__('Remove all passkeys for %1$s?', firstName),
        content: (
            <BodyText justify="center">
                { $.__('%1$s will have to log in using another method and create new Passkeys before logging in with Passkeys again.', firstName) }
            </BodyText>
        ), 
		icon: 'trash-can-regular',
		iconColor: 'warning-medium',
        iconV2Color: 'warning-medium',
        isOpen: true,
        isLoading: true,
        primaryActionText: $.__('Remove Passkeys'),
        title: $.__('Remove All Passkeys'),
    };

    window.BambooHR.Modal.setState(modalInitialState);

    (getPasskeyCredentials(userId))
        .then((creds) => {
            const count = Array.isArray(creds) ? creds.length : (creds?.length ?? 0);
            const hasPasskeys = count > 0;

            if (!hasPasskeys) {
                setMessage(
                    $.__('%1$s has no Passkeys to remove.', firstName),
                    'info',
                );
                window.BambooHR.Modal.setState({ isOpen: false });
                return;
            }

            window.BambooHR.Modal.setState(
                {
                    isLoading: false,
                    primaryActionText: $.__('Remove Passkeys'),
                    primaryAction() {
                        window.BambooHR.Modal.setState(
                            {
                                isProcessing: true,
                            },
                            true,
                        );

                        (deleteAllPasskeyCredentials(userId))
                            .then(() => {
                                setMessage(
                                    $.__('Success! All Passkeys removed for %1$s', firstName),
                                    'success',
                                );
                                onSuccess();
                                window.BambooHR.Modal.setState({ isOpen: false });
                            })
                            .catch((e) => {
                                console.error(e);
                                setMessage(
                                    $.__('There was an error removing the Passkeys. Please try again.'),
                                    'error',
                                );
                                window.BambooHR.Modal.setState(
                                    {
                                        isProcessing: false,
                                    },
                                    true,
                                );
                            });
                    },
                },
                true,
            );
        })
        .catch((e) => {
            console.error(e);
            setMessage(
                $.__('There was an error loading passkey information. Please try again.'),
                'error',
            );
            window.BambooHR.Modal.setState({ isOpen: false });
        });
}
